import { Link } from "@/i18n/navigation";
import { ComponentProps } from "react";

type LinkProps = ComponentProps<typeof Link> & {
  title: string;
  small?: boolean;
};

const FooterLink = ({ title, small, ...props }: LinkProps) => {
  return (
    <Link
      className={`text-ring md:hover:text-primary max-w-full break-words transition-all duration-200 ${small ? "text-[10px]" : "text-[15px]"}`}
      href={props.href}
    >
      {title}
    </Link>
  );
};

export default FooterLink;
